var exports = {
  "k": "x93eb46d8--1b142b--container",
  "j": "x93eb46d8--1b142b--spacer",
};

module.exports = exports;
